export default "__VITE_ASSET__r$uz7pxG__"